export default __webpack_public_path__ + "static/salao-de-festas-f03496dec2f4c0bb0f52fbf5d7f12db7.jpg";